import styled, { keyframes } from 'styled-components';
import { rgba } from 'polished';
import { margin, MarginProps } from '../../../components/styles';

const Loading = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

export const Loader = styled.div<MarginProps>`
  border-radius: ${({ theme }) => theme.radii.circle};
  width: 24px;
  height: 24px;
  font-size: 10px;
  position: relative;
  text-indent: -9999em;
  border: 4px solid ${({ theme }) => rgba(theme.backgroundColors.white, 0.2)};
  border-left: 4px solid ${({ theme }) => theme.backgroundColors.white};
  transform: translateZ(0);
  animation: ${Loading} 1.1s infinite linear;
  ${margin}

  &:after {
    border-radius: ${({ theme }) => theme.radii.circle};
    width: 10rem;
    height: 10rem;
  }
`;
